'use client';

import React, { createContext, ReactNode, useContext } from 'react';
import { useOnboarding } from '../hooks';

// Import the type from the hook to ensure consistency
type OnboardingHookReturn = ReturnType<typeof useOnboarding>;

const OnboardingContext = createContext<OnboardingHookReturn | undefined>(undefined);

export const OnboardingProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const onboardingHook = useOnboarding();

  return <OnboardingContext.Provider value={onboardingHook}>{children}</OnboardingContext.Provider>;
};

export const useOnboardingContext = () => {
  const context = useContext(OnboardingContext);
  if (context === undefined) {
    throw new Error('useOnboardingContext must be used within an OnboardingProvider');
  }
  return context;
};
